import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StyledHeaderButton } from '../Header/styles';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { setPageSelection, resetPageSelection } from '../../../containers/Editor/actions';

interface ButtonPageSelectionProps {
	isActive: boolean;
	isDisabled: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonPageSelection = ({ isActive, isDisabled, dispatch }: ButtonPageSelectionProps) => {
	const handleClick = () => {
		if (isActive) {
			dispatch(resetPageSelection());
		} else {
			dispatch(setPageSelection());
		}
	};

	return (
		<StyledHeaderButton
			width="18px"
			height="23px"
			disabled={isDisabled}
			onClick={handleClick}
		>
			{Utils.getSvgIcon(isActive
				? 'iconset_uprez_multiple_selection_active'
				: 'iconset_uprez_multiple_selection'
			)}
		</StyledHeaderButton>
	);
};

export default ButtonPageSelection;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonPageSelection/index.tsx